// Derive only the Settings image preview; never replace the attachment URL.
// Shared by Settings → Invitation file and the first event-details popup.
export const getSettingsThumbnailUrl = (source, fileType, size = 320) => {
  if (!String(fileType || "").split("/").includes("image")) return source;
  try {
    const url = new URL(source);
    if (url.protocol !== "https:" ||
        !(url.hostname === "ucarecdn.com" || url.hostname.endsWith(".ucarecdn.net") || url.hostname.endsWith(".ucarecd.net")) ||
        !/^\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\//i.test(url.pathname)) return source;
    // Keep the same file UUID and existing operations, excluding an optional filename.
    url.pathname = url.pathname.replace(/[^/]*$/, "") + `-/preview/${size}x${size}/`;
    return url.toString();
  } catch (_error) {
    return source;
  }
};
